import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/store/inventory/group",
        component: List,
        name: "store.inventory.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/inventory/group/create",
        component: Create,
        name: "store.inventory.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/inventory/group/:id/edit",
        component: Edit,
        name: "store.inventory.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
